<app-header [currentUrl]="currentUrl"></app-header>
<div class="main-container">
  <!-- leaving code for future use -->
  <!-- <div
    class="message-container"
    *ngIf="currentUrl === '/login' && !isExistingCustomer"
  >
    <div>
      <h2 class="message-container__title">Enroll in online access today.</h2>
      <p class="message-container__text">
        If you are a new customer, you will need to
        <strong><a routerLink="/register/enroll">create</a></strong> a new
        username and password to access your account. This is separate from any
        accounts you may have created to apply.
      </p>
    </div>
  </div> -->
  <div class="app-containerv2">
    <main class="main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
<app-footer></app-footer>
